import Block from '../../block'

export default class ShoppingcartProduct extends Block {
	static title = 'shoppingcart-product'

	constructor($el) {
		super($el)

		this.id = this.$el.data('id')
		this.delete = this.$el.findElement('delete')
		this.min = this.$el.findElement('min')
		this.plus = this.$el.findElement('plus')
		this.countInput = this.$el.findElement('count')

		// the input lags behind an in flight request, so keep the count in the instance
		this.count = parseInt(this.countInput.val()) || 0
		this.timer = null

		this.delete.on('click', () => this.deleteProduct())

		this.min.on('click', () => this.changeCount(-1))
		this.plus.on('click', () => this.changeCount(1))
		this.countInput.on('sl-change', () => {
			if (Number(this.countInput.val()) > Number(this.countInput.prop('max'))) {
				this.countInput.val(this.countInput.prop('max'))
				$(document).trigger('message:error', {
					message: this.countInput.data('quantityError'),
				})
			}

			this.count = parseInt(this.countInput.val()) || 0
			this.queueUpdate()
		})

		// an order confirmation renders the products read only, nothing to keep in sync
		if (this.countInput.length === 0) {
			return
		}

		// the cart is rendered more than once (mobile, desktop, popup), keep every copy in sync
		$(document).on('product:remove', (index, data) => {
			if (data.id == this.id) {
				this.$el.remove()
			}
		})

		$(document).on('product:update', (index, data) => {
			if (data.id == this.id) {
				this.setCount(data.product_count)
			}
		})
	}

	deleteProduct() {
		this.setDeleteLoading(true)
		const data = new FormData()

		data.append('ajax', true)
		data.append('id', this.id)
		data.append('delete', true)

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: '/shoppingcart',
			data: data,
		})
			.done((json) => {
				// check for errors
				if (json.status) {
					$(document).trigger('product:remove', json)
					// remove element from DOM
					this.$el.remove()
				} else {
					$(document).trigger('message:error', { message: json.error })
				}
			})
			.fail((jqxhr) => {
				$(document).trigger('message:error', {
					message: jqxhr.statusText,
				})
			})
			.always(() => this.setDeleteLoading(false))
	}

	changeCount(step) {
		const count = this.count + step

		if (count < 0) {
			return
		}

		this.count = count

		// show the click right away, the response only confirms it
		this.countInput.val(count)

		this.queueUpdate()
	}

	queueUpdate() {
		// clicks come in faster than the request returns, send the final count once
		clearTimeout(this.timer)

		this.timer = setTimeout(() => {
			this.timer = null
			this.updateProduct()
		}, 350)
	}

	updateProduct() {
		this.setNumberLoading(true)
		const data = new FormData()

		data.append('ajax', true)
		data.append('id', this.id)
		data.append('update', true)
		data.append('count', this.count)

		$.ajax({
			method: 'POST',
			processData: false,
			contentType: false,
			cache: false,
			url: '/shoppingcart',
			data: data,
		})
			.done((json) => {
				// check for errors
				if (!json.error) {
					// use the count of the cart itself, not the requested one
					const newCount =
						typeof json.product_count === 'undefined'
							? this.count
							: json.product_count

					$(document).trigger('product:update', {
						...json,
						product_count: newCount,
					})
				} else {
					$(document).trigger('message:error', { message: json.error })
				}
			})
			.fail((jqxhr) => {
				$(document).trigger('message:error', {
					message: jqxhr.statusText,
				})
			})
			.always(() => this.setNumberLoading(false))
	}

	setCount(count) {
		// a click on this copy is still waiting to be sent, that count wins
		if (this.timer) {
			return
		}

		// remove if count is 0 or lower
		if (count <= 0) {
			this.$el.remove()
			return
		}

		this.count = count
		this.countInput.val(count)

		if (
			count >= parseInt(this.countInput.prop('max')) &&
			this.$el.data('availability') != 'presale'
		) {
			this.plus.addModifier('disabled')
		} else {
			this.plus.removeModifier('disabled')
		}
	}

	setDeleteLoading(bool) {
		if (bool) {
			this.$el.findElement('loader').removeClass('hidden')
		} else {
			this.$el.findElement('loader').addClass('hidden')
		}
	}

	setNumberLoading(bool) {
		if (bool) {
			this.$el.findElement('number').addModifier('disabled')
			this.countInput.prop('disabled', true)
		} else {
			this.$el.findElement('number').removeModifier('disabled')
			this.countInput.prop('disabled', false)
		}
	}
}
